type HostObject = Record<string, unknown>;

const getCefSharp = () => (window as any).CefSharp;

const getWebViewHostObjects = (): Record<string, HostObject> | undefined =>
    (window as any).chrome?.webview?.hostObjects;

export const isCefSharpHost = (): boolean =>
    typeof getCefSharp()?.BindObjectAsync === "function";

export const isWebViewHost = (): boolean =>
    !isCefSharpHost() && getWebViewHostObjects() !== undefined;

/**
 * Resolves a host-registered object under either desktop host:
 * CefSharp (`BindObjectAsync` + window global) or WebView2 (`chrome.webview.hostObjects`).
 * Returns undefined when the host did not register the object (CefSharp only,
 * WebView2 proxies are created lazily and cannot be probed).
 */
export const bindHostObject = async (
    namespace: string,
): Promise<HostObject | undefined> => {
    if (isCefSharpHost()) {
        await getCefSharp().BindObjectAsync(namespace);
        return (window as any)[namespace] as HostObject | undefined;
    }

    const hostObjects = getWebViewHostObjects();
    if (!hostObjects) {
        throw new Error(
            "No desktop host bridge found (CefSharp or WebView2 hostObjects)",
        );
    }
    return hostObjects[namespace];
};
